<template>
  <div class="content-padding">
    <v-form
      role="form"
      v-on:submit.prevent="update"
      v-model="valid"
      ref="form"
      lazy-validation
    >
      <v-card>
        <v-toolbar color="primary" dark>
          <v-btn icon :to="{ name: 'FamilyGroupIndex' }">
            <v-icon color="white">arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ $t("edit") }}
            <v-icon slot="divider">chevron_right</v-icon>
            {{ $t("entity.familyGroup") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-progress-linear
          v-if="loading"
          v-bind:indeterminate="true"
        ></v-progress-linear>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-row row wrap>
              <v-col xs="12" sm="12" md="6">
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-text-field
                      :label="$t('name')"
                      v-model="familyGroup.familyGroupName"
                      :counter="128"
                      :rules="requiredRules"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="6">
                    <v-select
                      :label="$t('identificationType')"
                      v-model="familyGroup.identificationTypeId"
                      v-bind:items="identificationTypes"
                      item-text="identificationTypeName"
                      item-value="identificationTypeId"
                      autocomplete
                      :rules="requiredRules"
                      required
                    ></v-select>
                  </v-col>
                  <v-col xs="12" sm="12" md="6">
                    <v-text-field
                      :label="$t('identificationNumber')"
                      v-model="familyGroup.familyGroupIdentification"
                      :counter="32"
                      :rules="requiredRules"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-text-field
                      :label="$t('email')"
                      v-model="familyGroup.familyGroupEmail"
                      :counter="128"
                      :rules="emailRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-text-field
                      :label="$t('phone')"
                      v-model="familyGroup.familyGroupPhone"
                      :counter="24"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-text-field
                      :label="$tc('address', 1)"
                      v-model="familyGroup.familyGroupAddress"
                      :counter="128"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col xs="12" sm="12" md="6">
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-select
                      :label="$t('kindship')"
                      v-model="familyGroup.familyGroupKindship"
                      :items="familyKindships"
                      clearable
                      :rules="requiredRules"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-select
                      :label="$t('gender')"
                      v-model="familyGroup.familyGroupGender"
                      v-bind:items="familyGroupGenders"
                      clearable
                      :rules="requiredRules"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-text-field
                      :label="$t('occupation')"
                      v-model="familyGroup.familyGroupOccupation"
                      :counter="32"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-menu
                      v-model="dateModal"
                      :close-on-content-click="false"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          :label="$t('date')"
                          v-model="dateFormatted"
                          append-icon="event"
                          @blur="
                            familyGroup.familyGroupBirthdate = parseDate(
                              dateFormatted
                            )
                          "
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="familyGroup.familyGroupBirthdate"
                        @input="dateFormatted = formatDate($event)"
                        no-title
                        scrollable
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col xs="12" sm="12" md="12">
                    <v-checkbox
                      :label="$t('isCompensationBoxSubsidy')"
                      v-model="familyGroup.familyGroupIsCompensationBoxSubsidy"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <input type="hidden" v-model="familyGroup.familyGroupId" />
            <input type="hidden" v-model="familyGroup.personId" />
          </v-container>
          <v-btn type="submit" :loading="loading" dark color="accent">
            <v-icon>edit</v-icon>
            {{ $t("update") }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import { i18n } from "@/i18n";
import familyGroupEntity from "@/models/family_group";
import { responseException } from "@/assets/js/common";
export default {
  data() {
    return {
      loading: false,
      dateModal: false,
      dateFormatted: null,
      familyGroup: familyGroupEntity,
      familyGroupGenders: [
        {
          text: "Masculino",
          value: "M",
        },
        {
          text: "Femenino",
          value: "F",
        },
      ],
      familyKindships: [
        {
          text: "Cónyuge",
          value: "Cónyuge",
        },
        {
          text: "Padre",
          value: "Padre",
        },
        {
          text: "Madre",
          value: "Madre",
        },
        {
          text: "Hermano/a",
          value: "Hermano/a",
        },
        {
          text: "Hijo/a",
          value: "Hijo/a",
        }
      ],
      identificationTypes: [],
      valid: false,
      requiredRules: [(v) => !!v || i18n.t("valid.required")],
      emailRules: [
        (v) => !v || /[^@]+@[^@]+\.[^@]+/.test(v) || i18n.t("valid.email"),
      ]
    };
  },
  methods: {
    formatDate(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) {
        return null;
      }
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatToDate(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split("-");
      return `${day.substring(0, 2)}/${month}/${year}`;
    },
    get: function() {
      this.loading = true;
      this.$http.get(`hrm/familiesgroup/${this.$route.params.id}`).then(
        (response) => {
          this.familyGroup = response.body;

          if (this.familyGroup.familyGroupBirthdate.indexOf("0001") >= 0) {
            this.familyGroup.familyGroupBirthdate = null;
          }
          this.dateFormatted = this.formatToDate(
            this.familyGroup.familyGroupBirthdate
          );
          this.loading = false;
        },
        (response) => {
          this.$swal({
            icon: 'error',
            title: this.$t('errorOcurred'),
            text: responseException(response)
          })
          this.loading = false;
        }
      );
    },
    getIdentificationType() {
      this.$http.get("common/identificationtypes/").then(
        (response) => {
          this.identificationTypes = response.body;
        },
        (response) => {
          this.$swal({
            icon: 'error',
            title: this.$t('errorOcurred'),
            text: responseException(response)
          })
        }
      );
    },
    update: function() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$http
          .put(`hrm/familiesgroup/${this.$route.params.id}`, this.familyGroup, {
            emulateJSON: true,
          })
          .then(() => {
            this.$swal({
              icon: 'success',
              title: this.$t('processSuccess'),
              confirmButtonColor: '#8bc34a'
            })
            this.loading = false;
          },
          (response) => {
            this.$swal({
              icon: 'error',
              title: this.$t('errorOcurred'),
              text: responseException(response)
            })
            this.loading = false;
          }
        );
      }
    },
  },
  mounted: function() {
    this.get();
    this.getIdentificationType();
  },
};
</script>
